import { Card } from "../ui/card";
import { formatCurrency } from "./utils";

const FinancialSummary = ({ 
  invoicesOutstanding = 0, 
  job 
}) => {
  // Use backend-calculated totals for consistency with Jobs list
  const totalEstimate = job?.estimate_total || 0;
  const totalActual = job?.actual_total || 0;
  const profitLoss = job?.profit_loss || 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
      <Card className="stat-card" data-testid="total-estimate">
        <p className="stat-label">Total Estimate</p>
        <p className="stat-value mt-2">{formatCurrency(totalEstimate)}</p>
      </Card>
      <Card className="stat-card" data-testid="total-actual">
        <p className="stat-label">Total Actual</p>
        <p className="stat-value mt-2">{formatCurrency(totalActual)}</p>
      </Card>
      <Card className="stat-card" data-testid="profit-loss">
        <p className="stat-label">Profit/Loss</p>
        <p className={`stat-value mt-2 ${profitLoss >= 0 ? "text-green-600" : "text-red-600"}`}>
          {formatCurrency(profitLoss)}
        </p>
      </Card>
      <Card className="stat-card" data-testid="invoices-outstanding">
        <p className="stat-label">Invoices Outstanding</p>
        <p className={`stat-value mt-2 ${invoicesOutstanding > 0 ? "text-red-600" : "text-green-600"}`}>
          {formatCurrency(invoicesOutstanding)}
        </p>
      </Card>
    </div>
  );
};

export default FinancialSummary;
